/**
 * Hydrogen NL → kg conversion for the Burnaston overview cards.
 *
 * Product decision (See Wah Cheng): use the Enapter AEM EL 4.1 advertised production
 * figure — 500 NL/h → 1.0785 kg/24 h — as the conversion factor. That reduces to
 * 1 NL = 1.0785 / (500 × 24) kg ≈ 8.9875e-5 kg (≈ standard H₂ density 0.0899 g/NL).
 * The same factor converts a flow: kg/h = (NL/h) × KG_PER_NL.
 *
 * Source: https://enapter.com/en/product/aem-electrolyzer-el-4
 *
 * NOTE: the authoritative card calculations live in core (product decision: maths in
 * the backend). This constant is kept frontend-side for reference / any client-side
 * display of raw NL telemetry, and MUST match the factor core uses.
 */
export const KG_PER_NL = 1.0785 / (500 * 24) // ≈ 0.000089875

/** Convert a normal-litre quantity (or NL/h flow) to kilograms (or kg/h). */
export function nlToKg(nl: number | null | undefined): number | null {
  if (nl == null || !Number.isFinite(nl)) return null
  return nl * KG_PER_NL
}
